import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Button,
} from '@mui/material';
import Footer from '../navbar/Footer';

const rapport = {
  description: "Cliquez sur le bouton ci-dessous pour télécharger le rapport.",
  link: "recensementCafe", 
};

function RecensementCafe() {
  return (
    <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '20px', paddingTop: '20px' }}>
      <NavigationBar />
      <Container>
        <Typography variant="h4" align="justify" gutterBottom style={{ color: 'green', fontWeight: 'bold', marginTop: '20px' }}>
          Rapport du Recensement Général des Caféiers - Édition 2006-2007
        </Typography>
        
        <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '20px' }}>
         Après le Recensement Général des Caféiers de 1998, des conflits ont modifié les données caféicoles. En conséquence, l'OCIBU, en collaboration avec l'ISTEEBU, a réalisé le Recensement Général des Caféiers, Édition 2006-2007, afin de fournir des données fiables pour guider la réhabilitation du secteur caféier et soutenir l'économie nationale.
        </Typography>

        <div style={{ textAlign: 'justify', marginTop: '40px' }}>
          <Typography variant="h6" component="div" style={{ marginBottom: '20px' }}>
            {rapport.description}
          </Typography>
          <Button
            size="large"
            variant="contained"
            style={{ backgroundColor: 'green', color: 'white', '&:hover': { backgroundColor: '#45a049' } }}
            href={rapport.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {<DownloadIcon />}Télécharger
          </Button>
        </div>
      </Container>
      <br />
      <br />
      <Footer />
    </div>
  );
}

export default RecensementCafe;